<template>
    <div class="card-container">
      <div class="back-btn">
      <button @click="goBack" class="back-top-btn" v-if="!isHome">
        Voltar
      </button> 
    </div>
      <h4 class="index__login-title app-title with-bar">
        {{ pageTitle }}
        <div class="line-big"></div>
      </h4>
        <router-link v-for="option in currentList" :key="option.title" :to="option.route" tag="a" class="path__block">
          {{ option.title }}
        </router-link>
    </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      visitorOptions: [
        {
          title: "Tenho QR Code",
          route: "/home/visitors/qr-code"
        },
        {
          title: "Visita não agendada",
          route: "/home/visitors/non-scheduled"
        }
      ],
      homeOptions: [
        {
          title: 'Acessar como Colaborador',
          route: '/home/employees'
        },
        {
          title: 'Acessar como Visitante',
          route: '/home/visitors'
        }
      ]
    };

  },
  methods: {
    goBack() {
      this.$router.push("/home");
    },
  },
  computed: {
    pageTitle() {
     return this.isHome ? "Acesso como visitante" : 'Como deseja continuar?';
    },
    isHome() {
      return this.$route.name === "home";
    },
    currentList() {
      return this.isHome ? this.homeOptions : this.visitorOptions;
    }
  },
};
</script>

<style scoped>

.card-container{
    position: relative;
    display: flex;
    flex-direction: column;
    height: 80% !important;
    width: 80% !important;
    justify-content: center;
    
}
.options-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  height: 100%;
  gap: 20px;
  width: 100%;
}

.back-btn{
 position: absolute;
  right: 8px;
  top: 0px;
}

.path__block{
  width: 100%;
}

.back-top-btn {
  background-color: transparent;
  border: none;
  color: #e86b53;
  /* font-size: 1rem; */
  cursor: pointer;
}

.back-top-btn:hover {
  text-decoration: underline;
}

.back-top-btn i {
  font-size: 1.2rem;
}

.card-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 10px;
  width: 100%;
}

.index__login-title{
  margin-bottom: 20px;
  width: 80% !important;
}
</style>
